
import { STATUS } from "@interfaces/enum";

const getStatus = function (status, type = "bg") {
    let color = "";
    switch (status) {
        case STATUS.PENDING:
        case STATUS.UNPAID:
        case STATUS.FOR_APPROVAL:
        case STATUS.SUSPENDED:
        case STATUS.INACTIVE:
            color = "warning";
            break;
        case STATUS.SERVED:
        case STATUS.ACTIVATED:
        case STATUS.PAID:
        case STATUS.DONE:
        case STATUS.ACTIVE:
            color = "success";
            break;
        case STATUS.ACCEPTED:
        case STATUS.APPROVED:
            color = "primary";
            break;
        case STATUS.CANCELLED:
        case STATUS.DECLINED:
        case STATUS.EXPIRED:
        case STATUS.FAILED:
            color = "danger";
            break;
        case STATUS.ON_GOING:
        case STATUS.REFUNDED:
        case STATUS.DELETED:
        case STATUS.BOUNCED:    
        case STATUS.TRANSACTION_PENDING:
            color = "dark";
            break;
        case STATUS.ON_HOLD:
        case STATUS.RESCHEDULE:
        case STATUS.SENT:
            color = "info";
            break;
        case STATUS.QUEUED:
            color = "secondary";
            break;
        default:
            break;
    }
    return `${type}-${color}`;
}

const auditsItems = function (data) {
    const new_values = JSON.parse(data.new_values);
    const old_values = JSON.parse(data.old_values);
    let diffItems = [];
    for (const key in new_values) {
        const new_value = _.replace(new_values[key], " 00:00:00", "");
        const old_value = _.replace(old_values[key], " 00:00:00", "");
        let invalidKeys = [
            "updated_by",
            "created_by",
            "updated_at",
            "created_at"
        ];
        if (new_value != old_value && !_.includes(invalidKeys, key)) {
            let info = {
                key: key.replace(/_/g, " "),
                new_value,
                old_value
            };
            diffItems.push(info);
        }
    }
    return diffItems;
}

export default {
    getStatus,
    auditsItems
}